import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ActivityDetail from "../../../shared/components/ActivityDetail/ActivityDetail";
import {
  Directions,
  calenderConstants,
  centerActivityConstants,
  timezoneConstants,
  translationConstants,
} from "../../../constants";
import { Col, Form, Row } from "react-bootstrap";
import { authActions, centerActivityActions } from "../../../redux/actions";
import year_arrow_left from "../../../assets/images/icon/year_arrow_left.svg";
import year_arrow_right from "../../../assets/images/icon/year_arrow_right.svg";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import UpcomingCalender from "./Tabs/UpcomingCalender";
import PreviousCalender from "./Tabs/PreviousCalender";
import { success } from "../../../redux/actions/utilities";
import {
  dateToUTCWithTimezone,
  getEpochMonthStartAndEndDate,
} from "../../../system/utility-functions";
import calenderTick from "../../../assets/images/icon/calender_tick.svg";
import TimezoneDisplayText from "../../../shared/components/TimezoneDisplayText/TimezoneDisplayText";

const Calender = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const defaultDropDownValue = "";
  const { EVENT_TYPE, COMPETITION_TYPE, CENTER_TYPE } = calenderConstants;
  const [typeFilter, setTypeFilter] = useState([
    EVENT_TYPE,
    COMPETITION_TYPE,
    CENTER_TYPE,
  ]);

  const dateFilterQuery = (epochMonthWithFirstDate, epochMonthWithLastDate) => {
    return `((startDate >= ${epochMonthWithFirstDate} && startDate <= ${epochMonthWithLastDate}) || (endDate >= ${epochMonthWithFirstDate} && endDate <= ${epochMonthWithLastDate}))`;
  };

  //-------initial gridstate
  const getInitialGridState = () => {
    const currentDate = dateToUTCWithTimezone();
    const { epochMonthWithFirstDate, epochMonthWithLastDate } =
      getEpochMonthStartAndEndDate(currentDate);

    const typeConditions = [];
    if (typeFilter.length > 0) {
      if (typeFilter.includes(EVENT_TYPE)) {
        typeConditions.push(`type == ${JSON.stringify(EVENT_TYPE)}`);
      }
      if (typeFilter.includes(COMPETITION_TYPE)) {
        typeConditions.push(`type == ${JSON.stringify(COMPETITION_TYPE)}`);
      }
      if (typeFilter.includes(CENTER_TYPE)) {
        typeConditions.push(`type == ${JSON.stringify(CENTER_TYPE)}`);
      }
    }

    return {
      length: 7,
      pageNumber: 1,
      orderBy: "startDate asc",
      filterQuery: `endDate > ${dateToUTCWithTimezone().unix()} && (${typeConditions.join(
        " || "
      )}) && ${dateFilterQuery(
        epochMonthWithFirstDate,
        epochMonthWithLastDate
      )}`,
      search: null,
    };
  };
  const types = [
    {
      Key: t(translationConstants.events),
      Value: EVENT_TYPE,
    },
    {
      Key: t(translationConstants.competitions),
      Value: COMPETITION_TYPE,
    },
    {
      Key: t(translationConstants.CENTER_ACTIVITY_CALENDER),
      Value: CENTER_TYPE,
    },
  ];

  const [gridState, setGridState] = useState(getInitialGridState());
  const [key, setKey] = useState(0);
  const [calenderArray, setCalenderArray] = useState([]);
  const [isViewDetail, setIsViewDetail] = useState(null);
  const [activityDetailData, setActivityDetailData] = useState(null);
  const [spotFilter, setSpotFilterValue] = useState(defaultDropDownValue);

  const [dateFilter, setDateFilter] = useState(dateToUTCWithTimezone());
  const spots = useSelector((state) => state.LoginReducer.cities);

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const activityDataById = useSelector(
    (state) => state.centerActivityReducer.activityDataById
  );
  //-------reducers
  const centerListingReducer = useSelector(
    (state) => state.centerActivityReducer
  );
  //-------destructure reducers
  const { calenderData } = centerListingReducer;
  //-------Center Activities Listing
  const { pageData } = calenderData;
  //-------UseEffects
  const updateFilterQuery = useCallback(() => {
    const filterConditions = [];
    const { epochMonthWithFirstDate, epochMonthWithLastDate } =
      getEpochMonthStartAndEndDate(dateFilter);
    let orderByConditions;

    if (key === 0) {
      filterConditions.push(`endDate > ${dateToUTCWithTimezone().unix()}`);
      orderByConditions = "startDate asc";
    } else {
      filterConditions.push(`endDate < ${dateToUTCWithTimezone().unix()}`);
      orderByConditions = "startDate asc";
    }

    if (spotFilter !== "") {
      filterConditions.push(
        `(eventCityId == ${spotFilter} || spotCityId ==${spotFilter})`
      );
    }

    if (typeFilter.length > 0) {
      const typeConditions = [];
      if (typeFilter.includes(EVENT_TYPE)) {
        typeConditions.push(`type == ${JSON.stringify(EVENT_TYPE)}`);
      }
      if (typeFilter.includes(COMPETITION_TYPE)) {
        typeConditions.push(`type == ${JSON.stringify(COMPETITION_TYPE)}`);
      }
      if (typeFilter.includes(CENTER_TYPE)) {
        typeConditions.push(`type == ${JSON.stringify(CENTER_TYPE)}`);
      }
      filterConditions.push(`(${typeConditions.join(" || ")})`);
    }

    if (dateFilter) {
      filterConditions.push(
        dateFilterQuery(epochMonthWithFirstDate, epochMonthWithLastDate)
      );
    }

    const filterQuery = filterConditions.join(" && ");
    const orderBy = orderByConditions;
    setGridState((prevGridState) => ({
      ...prevGridState,
      filterQuery,
      orderBy,
    }));
  }, [spotFilter, key, typeFilter, dateFilter]);

  useEffect(() => {
    updateFilterQuery();
    //eslint-disable-next-line
  }, [updateFilterQuery]);

  useEffect(() => {
    dispatch(success({}, centerActivityConstants.ACTIVITY_DATA_BY_ID));
    dispatch(centerActivityActions.getCalenderEvents(gridState, typeFilter));
    const body = {
      length: null,
    };
    // dispatch(SpotActions.GetAllPublicSpots(body));
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    if (activityDataById.id) {
      setActivityDetailData(activityDataById);
      setIsViewDetail(true);
    } else {
      setIsViewDetail(false);
    }
  }, [activityDataById]);

  useEffect(() => {
    setCalenderArray(pageData);
    // eslint-disable-next-line
  }, [pageData]);

  const handleClearFilters = () => {
    setSpotFilterValue(defaultDropDownValue);
    setTypeFilter([EVENT_TYPE, COMPETITION_TYPE, CENTER_TYPE]);
    setDateFilter(dateToUTCWithTimezone());
  };

  const nextYear = () => {
    setDateFilter((prevDate) =>
      dateToUTCWithTimezone(prevDate).add(1, "month")
    );
  };

  const prevYear = () => {
    setDateFilter((prevDate) =>
      dateToUTCWithTimezone(prevDate).subtract(1, "month")
    );
  };

  const isMobile = useSelector((state) => {
    return state.systemReducer.isMobile;
  });

  return (
    <div className="container UserDiv pe-4">
      <div className="row py-2 ssf-calender">
        {!isViewDetail && (
          <Row className="public-competition d-flex flex-column flex-md-row">
            <Col md={12} lg={4}>
              <p className="UserTabHeading m-0">
                {t(translationConstants.SSF_CALENDER)}
              </p>
            </Col>
            <Col
              sm={12}
              lg={8}
              className="d-flex flex-column flex-lg-row gap-2 justify-content-lg-end justify-content-center align-items-center"
            >
              <div className=" col-lg-7 col-12 d-lg-flex  gap-2 justify-content-center justify-lg-content-end align-items-center">
                <div className="d-flex justify-content-md-end justify-content-center px-2 align-items-center w-100 m-1 m-md-1 m-lg-0">
                  <div className="py-3 d-flex">
                    {direction === Directions.rtl ? (
                      <img
                        src={year_arrow_right}
                        alt="center-logo"
                        onClick={nextYear}
                      />
                    ) : (
                      <img
                        src={year_arrow_left}
                        alt="center-logo"
                        onClick={prevYear}
                      />
                    )}
                    <span className="px-2">
                      {dateFilter.format(
                        timezoneConstants.monthYearFullWordFormat
                      )}
                    </span>
                    {direction === Directions.rtl ? (
                      <img
                        src={year_arrow_left}
                        alt="center-logo"
                        onClick={prevYear}
                      />
                    ) : (
                      <img
                        src={year_arrow_right}
                        alt="center-logo"
                        onClick={nextYear}
                      />
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center w-100 m-1 m-md-1 m-lg-0">
                  <Form.Group className="form-group-register m-0">
                    <Form.Select
                      className="custom-select-icon  filter-style"
                      onChange={(e) => {
                        setSpotFilterValue(e.target.value);
                      }}
                      value={spotFilter}
                      aria-label="Default select example"
                    >
                      <option value={defaultDropDownValue}>
                        {t(translationConstants.selectcity)}
                      </option>
                      {spots?.map((spot) => {
                        return (
                          <option key={spot?.id} value={spot?.id}>
                            {direction === Directions.rtl
                              ? spot.arabicName
                              : spot.name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </div>
                {(spotFilter !== defaultDropDownValue ||
                  !dateFilter.isSame(dateToUTCWithTimezone(), "month") ||
                  ![EVENT_TYPE, COMPETITION_TYPE, CENTER_TYPE].every((type) =>
                    typeFilter.includes(type)
                  )) && (
                  <div className="d-flex col-12 col-lg-2 justify-content-center align-items-center mx-2">
                    <div className="cancel-filter" onClick={handleClearFilters}>
                      {t(translationConstants.CLEAR_FILTERS)}
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )}
        {isViewDetail ? (
          <ActivityDetail
            activityData={activityDetailData}
            isBackButtonAllowed={true}
          />
        ) : (
          <div className="col-md-12 view-center-profile-scroll-tabs">
            <Tabs selectedIndex={key} onSelect={(k) => setKey(k)}>
              {/* Center Tab Links */}
              <div className="row">
                <div className="col-12">
                  <TabList>
                    <Tab eventKey="upcoming">
                      {t(translationConstants.UPCOMING)}
                    </Tab>
                    <Tab eventKey="previous">
                      {t(translationConstants.PREVIOUS)}
                    </Tab>
                  </TabList>
                </div>
              </div>
              <div className="row pe-md-3 mb-3">
                <div className="d-flex gap-md-2 justify-content-md-end justify-content-between">
                  {types.map((type) => {
                    const isSelected = typeFilter.includes(type.Value);
                    return (
                      <div
                        key={type.Value}
                        onClick={() => {
                          setTypeFilter((prevTypeFilter) =>
                            isSelected
                              ? prevTypeFilter.filter(
                                  (value) => value !== type.Value
                                )
                              : [...prevTypeFilter, type.Value]
                          );
                        }}
                        className={`filter-badge px-3 px-md-4 py-2 py-md-2 ${
                          !typeFilter.includes(type.Value) &&
                          "competition-filter-badge-border text-black"
                        }
                        ${
                          type.Value === EVENT_TYPE &&
                          typeFilter.includes(EVENT_TYPE) &&
                          "event-bg-color"
                        }
                        ${
                          type.Value === COMPETITION_TYPE &&
                          typeFilter.includes(COMPETITION_TYPE) &&
                          "competition-bg-color"
                        }
                        ${
                          type.Value === CENTER_TYPE &&
                          typeFilter.includes(CENTER_TYPE) &&
                          "activity-bg-color"
                        }`}
                      >
                        {isSelected && (
                          <h6
                            className={`m-0 ${
                              isMobile ? "font-12" : "font-14"
                            }`}
                          >
                            <div className="d-flex align-items-center">
                              <img src={calenderTick} alt="tick" />
                            </div>
                          </h6>
                        )}
                        <h6
                          className={`m-0 ${isMobile ? "font-12" : "font-14"}`}
                        >
                          {type.Key}
                        </h6>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Center General Tab */}
              <TabPanel>
                <TimezoneDisplayText />
                <UpcomingCalender
                  calenderArray={calenderArray}
                  setGridState={setGridState}
                  gridState={gridState}
                  flag={key}
                />
              </TabPanel>
              <TabPanel>
                <TimezoneDisplayText />
                <PreviousCalender
                  calenderArray={calenderArray}
                  setGridState={setGridState}
                  gridState={gridState}
                  flag={key}
                />
              </TabPanel>
            </Tabs>
          </div>
        )}
      </div>
    </div>
  );
};

export default Calender;
